export namespace ZIndexes {
  export const Nav: number = 1;
  /**
   * @deprecated ScrollablePane
   */
  export const ScrollablePane: number = 1;
  export const FocusStyle: number = 1;
  export const Coachmark: number = 1000;
  export const Layer: number = 1000000;
  export const KeytipLayer: number = 1000001;
}
